// extracted by mini-css-extract-plugin
export default {"progress":"BasicSuspense_progress__7Fagm"};